<template>
  <b-modal
      id="bv-modal-binaryOptionDialog"
      ref="modal"
      data-test-path="dialog-binaryOptionalDialog"
      @hide="onHide"
      @ok="onOk"
  >
    <template v-slot:modal-title>
      {{ title }}
    </template>

    <div class="d-block text-center" v-html="message"></div>

    <template #modal-footer="{close}">
      <b-container class="pl-0">
        <b-row>
          <b-col class="text-right">
            <b-button
                variant="plm-secondary"
                @click="onCreate"
            > {{ createTitle }}
            </b-button>
            <b-button
                data-test-path="yes-button-dialog"
                @click="onOk"
            >
              {{ addTitle }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </template>

  </b-modal>
</template>

<script>
export default {
  name: "BinaryOptionDialog",
  async beforeMount() {
    const params = this.$attrs.params || {};
    this.createTitle = params.createTitle || "Create organizations with a different name";
    this.addTitle = params.addTitle || "Add me to an existing company";
  },
  mounted() {
    let x = 5;
  },
  methods: {
    async onOk(ev) {
      this.isNewOrganization = false;
      if (this.resolve != null) {
        this.resolve({ success: true, isNewOrganization: this.isNewOrganization });
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },
    async onHide(ev) {
      if (this.resolve != null) {
        this.resolve({ success: false});
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },
    async onCreate(ev) {
      this.isNewOrganization = true;
      if (this.resolve != null) {
        this.resolve({ success: true, isNewOrganization: this.isNewOrganization });
        this.resolve = null;
      }
      this.$refs.modal.hide();
    },
    reset() {
      this.resolve = null;
      this.isNewOrganization = false;
    }
  },
  data: () => ({
    title: "title",
    message: "message",
    resolve: null,
    maxLength: 100,
    createTitle: "",
    addTitle: "",
    isNewOrganization: false
  })
}
</script>
